// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WOng","controls":"styles_controls__2A2GS","charLimit":"styles_charLimit__3FqTR","input":"styles_input__1e_9s","send":"styles_send__18wAH"};